var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProcedure5Year(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 25.5,
    r: 18.5,
    fill: "#33878E"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 25.5,
    r: 18.0889,
    stroke: "url(#paint0_linear_1966_29071)",
    strokeOpacity: 0.83,
    strokeWidth: 0.822222,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1966_29071)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 7,
    width: 37,
    height: 37,
    rx: 18.5,
    fill: "url(#paint1_linear_1966_29071)",
    fillOpacity: 0.83,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.56162,
    y: 6.56162,
    width: 37.8768,
    height: 37.8768,
    rx: 18.9384,
    stroke: "url(#paint2_linear_1966_29071)",
    strokeOpacity: 0.83,
    strokeWidth: 0.876757,
    style: {
      mixBlendMode: "overlay"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8807 35.625L22.1391 32.6917L18.8391 31.9583L19.1599 28.5667L16.9141 26L19.1599 23.4333L18.8391 20.0417L22.1391 19.3083L23.8807 16.375L26.9974 17.7042L30.1141 16.375L31.8557 19.3083L35.1557 20.0417L34.8349 23.4333L37.0807 26L34.8349 28.5667L35.1557 31.9583L31.8557 32.6917L30.1141 35.625L26.9974 34.2958L23.8807 35.625ZM24.6599 33.2875L26.9974 32.2792L29.3807 33.2875L30.6641 31.0875L33.1849 30.4917L32.9557 27.925L34.6516 26L32.9557 24.0292L33.1849 21.4625L30.6641 20.9125L29.3349 18.7125L26.9974 19.7208L24.6141 18.7125L23.3307 20.9125L20.8099 21.4625L21.0391 24.0292L19.3432 26L21.0391 27.925L20.8099 30.5375L23.3307 31.0875L24.6599 33.2875ZM26.0349 29.2542L31.2141 24.075L29.9307 22.7458L26.0349 26.6417L24.0641 24.7167L22.7807 26L26.0349 29.2542Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1966_29071",
    x: -235.137,
    y: -236.139,
    width: 523.274,
    height: 523.277,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.250309
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.12886
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1966_29071"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1966_29071",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1966_29071",
    x1: 9.99231,
    y1: 12.7429,
    x2: 22.7695,
    y2: 40.538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0865385,
    stopColor: "white",
    stopOpacity: 0.92
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.346154,
    stopColor: "white",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697115,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "white",
    stopOpacity: 0.56
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1966_29071",
    x1: 9.99231,
    y1: 12.7429,
    x2: 22.7695,
    y2: 40.538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "white",
    stopOpacity: 0.92
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352567,
    stopColor: "white",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.56
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1966_29071",
    x1: 9.99231,
    y1: 12.7429,
    x2: 16.5838,
    y2: 42.6093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "white",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.346154,
    stopColor: "white",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697115,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "white",
    stopOpacity: 0.56
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcedure5Year);
export default __webpack_public_path__ + "static/media/procedure5year.496fbf1f903679de7a5941eda97f8b53.svg";
export { ForwardRef as ReactComponent };